/**
 * Render-only schema trim. When the pane draws its own "Epic sign-in options"
 * control (shouldShowSpToggle), a VISIBLE `use_sp_login` property in the
 * workflow's schema (reset/smoke v2 publish it visible so ora's schema form
 * can send it) must not ALSO render as a form checkbox — two controls for one
 * value. The launch payload is unaffected, the trim is render-only: on the flat
 * contract (reset/smoke v2) the host-injected value is spread last and wins;
 * on the reshaped contract the payload is filtered against the full
 * published schema.
 * `x-hidden` declarations (carrier v2) are left exactly as published.
 */
export function withoutHostDrawnSignIn(
  schema: Record<string, unknown> | null,
  hostDrawsSignIn: boolean,
): Record<string, unknown> | null {
  if (!schema || !hostDrawsSignIn) return schema;
  const props = schema.properties as Record<string, Record<string, unknown>> | undefined;
  const field = props?.use_sp_login;
  if (!props || !field || field["x-hidden"] === true) return schema;
  const rest = Object.fromEntries(Object.entries(props).filter(([k]) => k !== "use_sp_login"));
  const required = Array.isArray(schema.required)
    ? (schema.required as string[]).filter((k) => k !== "use_sp_login")
    : undefined;
  return { ...schema, properties: rest, ...(required ? { required } : {}) };
}
